import { NodeType } from '@/enums/node-type.enum';
import { requestFigmaNodeLayerPickerAutoOpen } from '@/state/figmaNodeLayerPickerAutoOpen.state';
import { parseHandleKey } from '@/components/Nodes/Utils';
import type { FlowGraph } from '@/components/Recipe/FlowGraph';
import type { NodeId } from 'web';

export function requestFigmaNodeLayerPickerForTargetInput({
  graph,
  onAutoOpen,
  targetNodeId,
  targetHandleId,
}: {
  graph: FlowGraph;
  onAutoOpen: () => void;
  targetNodeId: NodeId;
  targetHandleId: string;
}) {
  const targetInputId = parseHandleKey(targetHandleId, targetNodeId, 'input');
  if (!targetInputId) return;
  if (graph.store.getNodeNullable(targetNodeId)?.type !== NodeType.FigmaNode) return;

  requestFigmaNodeLayerPickerAutoOpen(targetNodeId, targetInputId);
  onAutoOpen();
}
